import { render, staticRenderFns } from "./PedidoIngresado.vue?vue&type=template&id=0baf1134&scoped=true"
import script from "./PedidoIngresado.vue?vue&type=script&lang=js"
export * from "./PedidoIngresado.vue?vue&type=script&lang=js"
import style0 from "./PedidoIngresado.vue?vue&type=style&index=0&id=0baf1134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf1134",
  null
  
)

export default component.exports